import styled from "styled-components";

export const Input = styled.input`
    width: 100%;
    font-weight: 400;
    color: #2770d8;
    font-size: 18px;
    border: 0;
    outline: 0;
    background: #f8f8f8;
    border-radius: 36px;
    margin-bottom: 20px;
    padding: 25px 35px;
    outline: 0;
    &::placeholder {
        font-weight: 400;
        color: rgba(39, 112, 216, 0.6);
        font-size: 20px;
    }
`;
